import script from "./ViewHtmlFAQs.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewHtmlFAQs.vue?vue&type=script&setup=true&lang=js"

import "./ViewHtmlFAQs.vue?vue&type=style&index=0&id=5aaeb46e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aaeb46e"]])

export default __exports__